"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadExercises = void 0;
const react_1 = require("react");
const js_cookie_1 = __importDefault(require("js-cookie"));
const _params_1 = require("@params");
const useLoadExercises = () => {
    const [exercises, setExercises] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const language = js_cookie_1.default.get("lang_id");
        fetch(_params_1.apiHost + `/exercises/list?language=${language}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken"),
            },
        })
            .then((response) => response.json())
            .then((result) => {
            setExercises(result);
        });
    }, []);
    return exercises;
};
exports.useLoadExercises = useLoadExercises;
